// DEV-ONLY: isolierte Vorschau der ECHTEN /abo-Bühne „Wiedervorlage/Ampel"
// (Komponente AboWiedervorlageStage) inkl. abo.css. Nur zur visuellen Prüfung von
// Desktop- und 390-px-Mobile-Layout. Kein Einfluss auf /abo.
import { useEffect, useRef } from "react";
import AboWiedervorlageStage from "@/components/abo/AboWiedervorlageStage";
import "@/pages/abo/abo.css";

const OUTFIT =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap";

export default function AboWvStageDev() {
  const ref = useRef(null);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = OUTFIT;
    document.head.appendChild(link);
    // reveal-Elemente ohne IntersectionObserver sichtbar machen
    ref.current
      ?.querySelectorAll(".reveal")
      .forEach((el) => el.classList.add("in"));
    return () => link.remove();
  }, []);
  return (
    <div
      className="abo-root"
      lang="de"
      ref={ref}
      data-testid="abo-wv-stage-dev"
      style={{ minHeight: "100vh" }}
    >
      <style>{`[data-testid="abo-wv-stage-dev"] .reveal{opacity:1 !important;transform:none !important;}`}</style>
      <AboWiedervorlageStage />
    </div>
  );
}
